import { ListUser } from "models/list-user";
import { StateCreator } from "zustand";

export interface ListUserSlice {
  listUser: ListUser | undefined;
}

export const createListUserSlice: StateCreator<
  ListUserSlice,
  [],
  [],
  ListUserSlice
> = () => ({
  listUser: undefined,
});
